import apiClient from '../lib/apiClient';
import { PATIENT_QUESTIONNAIRES } from '../constants/apiEndpoints';

interface patinetQuestionnairesParams {
  patient_id: number | undefined;
  type: string;
}

export interface questionnaireAnswer {
  id: number;
  answer: string | string[] | null;
}

export interface updatePatientQuestionnairePayload {
  patient: {
    id: number;
    history_type: string;
    questionnaires: questionnaireAnswer[];
  };
}

export async function patientQuestionnaires(
  params: patinetQuestionnairesParams
) {
  const response = await apiClient.get(PATIENT_QUESTIONNAIRES, { params });

  return { questionnaires: response.data.data };
}

export async function updatePatientQuestionnaire(
  payload: updatePatientQuestionnairePayload
) {
  const response = await apiClient.post(PATIENT_QUESTIONNAIRES, payload);

  return response.data;
}
